const checkoutInit = () => {
  const checkoutForm = document.querySelector('.woocommerce-checkout');
  if (!checkoutForm) return;

  // Coupon Accordion
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('.form-coupon__toggle');
    if (toggle) {
      const coupon = toggle.closest('[data-coupon-accordion]');
      if (!coupon) return;

      const content = coupon.querySelector('.form-coupon__content');
      if (!content) return;

      const expanded = toggle.getAttribute('aria-expanded') === 'true';

      toggle.setAttribute('aria-expanded', String(!expanded));
      content.hidden = expanded;

      return;
    }

    const applyBtn = e.target.closest('.form-coupon__apply');
    if (!applyBtn) return;

    const coupon = applyBtn.closest('[data-coupon-accordion]');
    if (!coupon) return;

    const input = coupon.querySelector('.form-coupon__input');
    if (!input) return;

    const value = input.value.trim();
    if (!value) return;

    const couponForm = document.querySelector('.checkout_coupon');
    if (!couponForm) return;

    const realCouponInput = couponForm.querySelector(
      'input[name="coupon_code"]'
    );
    const realApplyBtn = couponForm.querySelector(
      'button[name="apply_coupon"]'
    );

    if (!realCouponInput || !realApplyBtn) return;

    realCouponInput.value = value;
    realApplyBtn.click();
  });

  const renderCouponError = (message) => {
    const noticesWrapper = document.querySelector('.woocommerce-notices-wrapper');
    if (!noticesWrapper) return;


    noticesWrapper
      .querySelectorAll('.form-coupon__error')
      .forEach(el => el.remove());

    const error = document.createElement('div');
    error.className = 'form-coupon__error woocommerce-error';
    error.setAttribute('role', 'alert');
    error.innerHTML = message;

    noticesWrapper.append(error);
  };

  jQuery(document.body).on('updated_checkout', function () {

    const errorNotice = document.querySelector('#coupon-error-notice');
    if (!errorNotice) return;

    const message = errorNotice.innerHTML;

    renderCouponError(message);
  });


  // Checkout fields populate locations
  document.addEventListener('change', function (e) {
    if (!e.target.name.startsWith('mixed_city_')) return;

    const regionSelect = e.target;
    const cartKey = regionSelect.name.replace('mixed_city_', '');
    const courseId = document.querySelector('[name="mixed_course_' + cartKey + '"]').value;
    const placeSelect = document.querySelector(
      `select[name="mixed_place_${cartKey}"]`
    );

    if (!placeSelect) return;

    placeSelect.innerHTML = '<option value="">'+ rcTranslate.loading +'</option>';

    const data = new FormData();
    data.append('action', 'get_locations_by_region');
    data.append('region', regionSelect.value);
    data.append('course_id', courseId);
    data.append("_ajax_nonce", rcData.nonce);

    fetch(rcData.ajaxUrl, {
      method: 'POST',
      body: data,
    })
      .then(res => res.json())
      .then(res => {
        placeSelect.innerHTML = '<option value="">'+ rcTranslate.select_location +'</option>';

        if (!res.success) return;

        Object.entries(res.data).forEach(([value, label]) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = label;
          placeSelect.appendChild(option);
        });
      });
  });

  // Checkout fields populate dates
  document.addEventListener('change', function (e) {

    // LOCATION → DATES
    if (e.target.name.startsWith('mixed_place_')) {

      const placeSelect = e.target;
      const cartKey = placeSelect.name.replace('mixed_place_', '');

      const dateSelect = document.querySelector(
        `select[name="mixed_date_${cartKey}"]`
      );

      const timeSelect = document.querySelector(
        `select[name="mixed_time_${cartKey}"]`
      );

      if (!dateSelect || !timeSelect) return;

      dateSelect.innerHTML = '<option value="">'+ rcTranslate.loading +'</option>';
      timeSelect.innerHTML = '<option value="">'+ rcTranslate.select_time +'</option>';

      const data = new FormData();
      data.append('action', 'get_dates_by_location');
      data.append('location', placeSelect.value);
      data.append("_ajax_nonce", rcData.nonce);

      fetch(rcData.ajaxUrl, {
        method: 'POST',
        body: data,
      })
        .then(r => r.json())
        .then(res => {
          dateSelect.innerHTML = '<option value="">'+ rcTranslate.select_date +'</option>';

          if (!res.success) return;

          Object.entries(res.data).forEach(([value, label]) => {
            const option = document.createElement('option');
            option.value = value;
            option.textContent = label;
            dateSelect.appendChild(option);
          });
        });
    }

    if (e.target.name.startsWith('mixed_date_')) {

      const dateSelect = e.target;
      const cartKey = dateSelect.name.replace('mixed_date_', '');

      const placeSelect = document.querySelector(
        `select[name="mixed_place_${cartKey}"]`
      );

      const timeSelect = document.querySelector(
        `select[name="mixed_time_${cartKey}"]`
      );

      if (!placeSelect || !timeSelect) return;

      timeSelect.innerHTML = '<option value="">'+ rcTranslate.loading +'</option>';

      const data = new FormData();
      data.append('action', 'get_times_by_location_date');
      data.append('location', placeSelect.value);
      data.append('date', dateSelect.value);
      data.append("_ajax_nonce", rcData.nonce);

      fetch(rcData.ajaxUrl, {
        method: 'POST',
        body: data,
      })
        .then(r => r.json())
        .then(res => {
          timeSelect.innerHTML = '<option value="">'+ rcTranslate.select_time +'</option>';

          if (!res.success) return;

          Object.entries(res.data).forEach(([value, label]) => {
            const option = document.createElement('option');
            option.value = value;
            option.textContent = label;
            timeSelect.appendChild(option);
          });
        });
    }
  });

  // Mobile totals
  jQuery(document.body).on(
    'updated_checkout',
    function () {
      syncMobileOrderTotal();
    }
  );

  const syncMobileOrderTotal = () => {
    const source = document.querySelector(
      '.order-total .woocommerce-Price-amount'
    );

    const target = document.querySelector(
      '.mobile-totals .woocommerce-Price-amount'
    );

    if (!source || !target) return;

    target.innerHTML = source.innerHTML;
  };

  document.addEventListener('click', (e) => {
    const mobileBtn = e.target.closest('.mobile-place-order');
    if (!mobileBtn) return;

    e.preventDefault();

    const realBtn = document.querySelector(
      '#place_order'
    );

    realBtn?.click();
  });


  // Checkout password fields
  const checkbox = document.getElementById('create_account_option');
  const fields = document.getElementById('account_password_fields');

  if (!checkbox || !fields) return;

  const toggle = () => {
    fields.style.display = checkbox.checked ? 'block' : 'none';
  };

  checkbox.addEventListener('change', toggle);
  toggle();

}

export default checkoutInit;